import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=4f0fd235&scoped=true"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"
import style0 from "./InputField.vue?vue&type=style&index=0&id=4f0fd235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0fd235",
  null
  
)

export default component.exports